/**
 * AiBadge — visible marker for content generated by an AI model.
 *
 * Compliance context (v1.44):
 * Article 50(4) of the EU AI Act + best practice require that AI-
 * generated content shown to end users is clearly labelled. This is
 * the single component we use across the whole portal so labelling is
 * consistent (no "some places yes, some places no") and one edit
 * updates every surface.
 *
 * Usage:
 *   <AiBadge />                          ← default "✨ Generato con AI"
 *   <AiBadge label="Testo AI" />         ← custom short label
 *   <AiBadge variant="inline" />         ← smaller, inline w/ text
 *   <AiBadge tooltip="Model: Claude Haiku 4.5" />
 *
 * The tooltip is optional: it helps power users understand which model
 * produced the output but keeps the visible chrome minimal.
 */
import React from "react";
import { Sparkles } from "lucide-react";

export function AiBadge({
  label = "Generato con AI",
  variant = "default",
  tooltip = "Questo contenuto è stato generato da un modello di intelligenza artificiale. Rileggilo prima di pubblicarlo.",
  className = "",
}) {
  if (variant === "inline") {
    return (
      <span
        data-testid="ai-badge-inline"
        title={tooltip}
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-emerald-50 border border-emerald-300 text-emerald-800 text-[10px] font-semibold leading-none align-middle ${className}`}
      >
        <Sparkles className="h-2.5 w-2.5" />
        <span>{label}</span>
      </span>
    );
  }
  return (
    <div
      data-testid="ai-badge"
      title={tooltip}
      className={`inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-emerald-50 border border-emerald-300 text-emerald-800 text-[11px] font-semibold ${className}`}
    >
      <Sparkles className="h-3 w-3" />
      <span>{label}</span>
    </div>
  );
}
